<ng-container>
  <tr [ngClass]="cssClassName">
    <td easEditorBookingItemInheritableTypeHeader [inheritableType]="itemSetting.inheritableType">
      {{ itemSetting.getTitle() }}
    </td>
    <td>
      <span *ngIf="itemSetting.inheritableType === 'empty'" class="text-muted" i18n>
        Not set
      </span>
      <ng-container *ngIf="itemSetting.inheritableType !== 'empty'">
        <ng-container [ngSwitch]="itemSetting.settingClassName">
          <eas-editor-booking-item-setting-value-booking-date *ngSwitchCase="'BookingDate'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-booking-date>
          <eas-editor-booking-item-setting-value-booking-window *ngSwitchCase="'BookingWindow'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-booking-window>
          <eas-editor-booking-item-setting-value-capacity *ngSwitchCase="'Capacity'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-capacity>
          <eas-editor-booking-item-setting-value-eligibility *ngSwitchCase="'Eligibility'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-eligibility>
          <eas-editor-booking-item-setting-value-pricing *ngSwitchCase="'Pricing'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-pricing>
          <eas-editor-booking-item-setting-value-venue *ngSwitchCase="'Venue'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-venue>
          <eas-editor-booking-item-setting-value-workflow *ngSwitchCase="'Workflow'" [itemSetting]="itemSetting">
          </eas-editor-booking-item-setting-value-workflow>
        </ng-container>
      </ng-container>
      <button mat-icon-button
        aria-label="Edit setting"
        i18n-aria-label
        (click)="onEdit()">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
    <td>
      <eas-editor-booking-item-inheritable-type-badge *ngIf="itemSetting.inheritableType !== 'empty'" [inheritableType]="itemSetting.inheritableType">
      </eas-editor-booking-item-inheritable-type-badge>
    </td>
  </tr>
</ng-container>
